import http from '@/common/http.js'

function list(data,callback) {
	http.request({
		url		: 'ali/list?'+data,
		success: (res) => {
			callback && callback(res);
		}
	})
}
function create(data,success,error) {
	http.request({
		url		: 'ali/create',
		data	: data,
		success,
		error,
	})
}
function confirm(data,callback) {
	http.request({
		url		: 'ali/confirm',
		data	: data,
		success: (res) => {
			callback && callback(res);
		}
	})
}
function info(data,callback) {
	http.request({
		url		: 'ali/info',
		data	: data,
		success: (res) => {
			callback && callback(res);
		}
	})
}
export default {
	list,	
	create,		
	confirm,
	info,
}